var render = function render(){var _vm=this,_c=_vm._self._c;return _c('figure',{staticClass:"image-container",class:{
        'text': _vm.module.view == 'content-wide',
        'wide': !_vm.module.view || _vm.module.view == 'default',
        'full': _vm.module.view == 'no-padding'
    }},[_c('div',{staticClass:"image-wrapper"},[_c('WebpImage',{attrs:{"image":{
                width: _vm.module.image.width,
                height: _vm.module.image.height,
                src: _vm.module.src
            }},nativeOn:{"click":function($event){return _vm.$parent.openGallery.apply(null, arguments)}}})],1),_vm._v(" "),(_vm.module.showCaption && _vm.module.caption)?_c('figcaption',{staticClass:"f-small color-gray-0 mt-2 caption-material",domProps:{"innerHTML":_vm._s(_vm.module.caption)}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }